module.exports = __webpack_public_path__ + "img/HowWeAssess_tools.495c52fe.svg";